<template>
  <div class="wrap">
    <div class="headers">
      <div class="logo">
        <a href="https://bluexad.ai/" target="_blank">
          <img src="../../assets/img/logo_col.png">
          <span class="logo-text">| {{$t("login.logoDevPlatform")}}</span>
        </a>
      </div>
    </div>
    <div class="left_bottom_text_plain">
      <p>{{$t("login.cooperation")}} {{$t('login.company')}}</p>
    </div>

    <div class="header-right">
      <div class="header-user-con">
        <el-dropdown trigger="click" @command="langChange">
          <span class="el-dropdown-link">
            {{language}} <i class="el-icon-caret-bottom"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item divided  command="zh">中文</el-dropdown-item>
            <el-dropdown-item divided  command="en">English</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="ms-login">
      <el-form size="large">
        <el-row class="ms-title">
          <el-col :span="24">
            <p class="user-behavior">{{$t("login.welcomeLogin")}}</p>
            <p class="devPlatform">{{$t("login.devPlatform")}}</p>
          </el-col>
        </el-row>
        <el-tabs v-model="type" @tab-click="handleClick" stretch>
          <el-tab-pane :label="$t('login.emailLogin')" name="1">
            <el-form :model="loginEmailData" :rules="emailRules" ref="emailRef" class="ms-content" size="large">
              <el-form-item label prop="email">
                <el-input
                  v-model.trim="loginEmailData.email"
                  :placeholder="$t('forget.Email')"
                  prefix-icon="el-icon-message"
                ></el-input>
              </el-form-item>
              <el-form-item label prop="password">
                <el-input
                  type="password"
                  show-password
                  v-model="loginEmailData.password"
                  prefix-icon="el-icon-lock"
                  :placeholder="$t('login.password') +','+ $t('login.min')"
                ></el-input>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane :label="$t('login.mobileLogin')" name="2">
            <el-form :model="loginMobileData" :rules="mobileRules" ref="mobileRef" class="ms-content" size="large">
              <el-form-item label prop="mobile">
                <el-input
                  :placeholder="$t('forget.tel')"
                  v-model.trim="loginMobileData.mobile"
                  prefix-icon="el-icon-mobile">
                  <template slot="prepend">
                    <el-select
                      class="itu-code"
                      v-model="loginMobileData.itu_code"
                      style="width: 150px"
                    >
                      <el-option
                        v-for="item in ituList"
                        :key="item.value"
                        :label="`${item.value}`"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item class="captcha" label prop="captcha">
                <el-input v-model="loginMobileData.captcha" prefix-icon="el-icon-check" :placeholder="$t('login.imgCode')"></el-input>
                <div class="captcha-img">
                  <img :src="captchaUrl" />
                  <div @click="handleCaptcha" class="cover"></div>
                </div>
              </el-form-item>
              <el-form-item class="send-code-info" label prop="sms_code">
                <el-input
                  v-model.trim="loginMobileData.sms_code"
                  prefix-icon="el-icon-chat-line-square"
                  :placeholder="$t('forget.msgCode')"
                ></el-input>
                <el-button
                  class="send-code-btn"
                  @click="handleSendCode"
                  :disabled="showSendCodeBtn"
                  type="primary"
                >{{ sendCodeBtnName }}</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
  
        <el-form-item label prop="rememberMe">
          <el-col class="tip-msg" :span="12">
            <el-checkbox text-color="#9b9b9c" v-model="rememberMe">{{$t("login.autoLogin")}}</el-checkbox>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button class="submit-button" type="primary" @click="submitForm('ruleForm')">{{$t("login.login")}}</el-button>
        </el-form-item>
        <el-form-item>
          <p class="toSignUp" @click="handleSignup">{{$t("login.register")}}</p>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import util from '@/utils/util'

export default {
  data() {
    return {
      captchaUrl: "",
      sendCodeBtnName: "Get Code",
      type: "1", //类型:1邮箱登录,2手机号登录
      timer: null,
      loginEmailData: {
        email: "", //邮箱
        password: "", //密码
        type: 1, //类型:1邮箱登录,2手机号登录
        area: 2 // 海外账户
      },
      loginMobileData: {
        mobile: "", //手机号
        captcha: "", //图形验证码
        sms_code: "", //短信验证码
        itu_code: "+1", //国际区号，默认为美国
        type: 2, //类型:1邮箱登录,2手机号登录
        area: 2 // 海外账户
      },
      ituList: [
        { value: "+1",label: "USA/CAN"},
        { value: "+7",label: "RUS"},
        { value: "+60",label: "MYS"},
        { value: "+62",label: "IDN"},
        { value: "+65",label: "SGP"},
        { value: "+84",label: "VNM"},
        { value: "+86",label: "CHN"},
        { value: "+852",label: "HKG"},
        { value: "+853",label: "MAC"},
        { value: "+886",label: "TWN"}
      ],
      rememberMe: true,
      language: 'English',
    };
  },
  computed: {
    showSendCodeBtn() {
      const isValidCaptcha = this.loginMobileData.captcha.length === 4;
      const isValidPhone = this.loginMobileData.mobile.length >= 5 && this.loginMobileData.mobile.length <= 16;
      
      return !isValidCaptcha && !isValidPhone;
    }, 
    emailRules() {
      return {
        email: [
          { type: 'email', message: this.$t('login.emailError'), trigger: ['blur', 'change'] },
          { required: true, message: this.$t('login.emailCheck'), trigger: "blur" }
        ],
        password: [
          { required: true, message:  this.$t('login.pwdCheck'), trigger: "blur" },
          { min: 6, message: this.$t('login.min'), trigger: "blur" }
        ],
      }
    },
    mobileRules() {
      return {
        mobile: [{ validator: this.validatePhone, trigger: "blur" }],
        captcha: [{ required: true, message: this.$t('login.codeCheck'), trigger: "blur" }],
        sms_code: [
          { required: true, message: this.$t('forget.smsCheck'), trigger: "blur" }
        ]
      }
    }
  },
  created() {
    this.sendCodeBtnName = this.$t('forget.getCode')
    var lang = localStorage.getItem("lang")
    if(lang == 'en') {
      this.language = 'English'
      this.$i18n.locale = 'en'
    } else if (lang == 'zh') {
      this.language = '中文'
      this.$i18n.locale = 'zh'
    } else {
      // 默认英文
      this.language = 'English'
      this.$i18n.locale = 'en'
    }
    this.handleCaptcha();
  },
  methods: {
    // 中英文切换
    langChange(command) {
      if (command == 'zh') {
        this.language = '中文'
        this.$i18n.locale = 'zh'
      } else {
        this.language = 'English'
        this.$i18n.locale = 'en'
      }
      localStorage.setItem("lang", command)
    },
    // 验证手机号
    validatePhone(rule, value, callback) {
      if (!value) {
        return callback(new Error(this.$t('login.phoneCheck')))
      }
      if (value.length < 5 || value.length > 16) {
        return callback(new Error(this.$t('login.phoneLength')))
      }
      callback()
    },
    handleClick() {
      this.captchaUrl = ''
      this.handleCaptcha()
    },
    // 获取图形验证码
    handleCaptcha() {
      // 这里应该调用获取图形验证码的API
      this.captchaUrl = `https://api.example.com/captcha?time=${new Date().getTime()}`
    },
    // 发送验证码
    handleSendCode() {
      // 验证手机号和图形验证码
      this.$refs.mobileRef.validateField('mobile')
      this.$refs.mobileRef.validateField('captcha')
      
      // 假设验证通过
      this.showSendCodeBtn = true
      let count = 60
      this.sendCodeBtnName = `${count}s`
      this.timer = setInterval(() => {
        count--
        this.sendCodeBtnName = `${count}s`
        if (count <= 0) {
          clearInterval(this.timer)
          this.sendCodeBtnName = this.$t('forget.getCode')
          this.showSendCodeBtn = false
        }
      }, 1000)
      
      // 这里应该调用发送短信验证码的API
    },
    // 提交表单
    submitForm() {
      if (this.type == '1') {
        this.$refs.emailRef.validate(valid => {
          if (valid) {
            // 调用登录API
            this.login(this.loginEmailData)
          }
        })
      } else {
        this.$refs.mobileRef.validate(valid => {
          if (valid) {
            // 调用登录API
            this.login(this.loginMobileData)
          }
        })
      }
    },
    // 登录
    login(data) {
      // 这里应该调用登录API
      // 假设登录成功
      util.setCookie('token', 'example-token', 7)
      util.setCookie('user', JSON.stringify({area: 2}), 7)
      this.$router.push('/abroad/app/list')
    },
    // 跳转到注册
    handleSignup() {
      this.$router.push('/signup?area=2')
    }
  }
}
</script>
<style scoped lang="scss">

</style>